const

CustomSelect = {
	/**
	 * Инициализация всех селектов на странице
	 * Обрабатывает все элементы с классом .select, которые ещё не стилизованы
	 */
	init() {
		// Стилизуем все необработанные селекты
		jQuery('.select:not(.ok)').each((index, element) => {
			const
				select = jQuery(element);

			let params = {};

			try {
				params = JSON.parse(select.attr('data-select'));
			} catch(e) {
				params = {placeholder: 'Выберите значение...'};
			}

			this.stylize(select, params);
		});

		// Закрытие всех открытых списков при клике вне их области
		jQuery(document).on('mouseup', (event) => {
			if (!jQuery('.select__wrapper.ok .select__label').is(event.target)) {
				const
					wrapper = jQuery('.select__wrapper');

				wrapper.removeClass('opened');
				wrapper.find('.select__list').removeClass('opened');
			}
		});
	},

	/**
	 * Проверка существования переменной
	 *
	 * @param {*} val - проверяемое значение
	 * @returns {boolean} true если переменная определена
	 */
	isset(val) {
		return typeof val !== 'undefined';
	},

	/**
	 * Стилизация обычного select в кастомный
	 * Создаёт обёртку, лейбл и выпадающий список
	 *
	 * @param {jQuery} select - jQuery объект исходного select
	 * @param {Object} params - параметры стилизации
	 */
	stylize(select, params) {
		const
			options = select.find('option'),
			elements = {};

		// Создаём обёртку и скрываем оригинальный select
		select.wrap('<div class="select__wrapper">').hide();
		elements.wrapper = select.closest('.select__wrapper');

		// Создаём видимый лейбл вместо select
		elements.label = jQuery('<div class="select__label">').text(params.placeholder);
		elements.label.insertAfter(select);

		// Создаём выпадающий список
		elements.ul = jQuery('<ul class="select__list">');
		elements.ul.insertAfter(elements.label);

		// Наполняем список опциями
		options.each((i, option) => {
			const
				li = jQuery('<li class="select__list-item">'),
				optionEl = jQuery(option);
			
			// Помечаем элемент для сброса, если указан
			if (i === params.clearItem)
				li.addClass('select__list-item--clear');

			li.html(`<span>${optionEl.text()}</span>`);
			li.attr('data-value', optionEl.val());
			li.appendTo(elements.ul);

			li.on('click', this.selectItem.bind(this));
		});

		// Устанавливаем начальное состояние
		elements.label.addClass('placeholder');

		if (this.isset(params.default) && params.default !== -1) {
			// Если default - это индекс, получаем value соответствующей опции
			const
				defaultValue = typeof params.default === 'number' ? 
					options.eq(params.default).val() : 
					params.default;
			
			this.change(select, defaultValue, false);
		}
		
		if (this.isset(params.default) && params.default !== -1)
			this.change(select, params.default, false);

		// Вешаем обработчики событий
		elements.label.on('click', this.open.bind(this));

		// Применяем дополнительные CSS-классы
		if (this.isset(params.wrapperClass))
			elements.wrapper.addClass(params.wrapperClass);
		
		select.addClass('ok');
		elements.wrapper.addClass('ok');
	},

	/**
	 * Получение всех элементов кастомного селекта по исходному select
	 *
	 * @param {jQuery} select - jQuery объект исходного select
	 * @returns {Object} объект с элементами интерфейса и параметрами
	 */
	getElements(select) {
		const
			wrapper = select.closest('.select__wrapper');

		let result = {
			wrapper,
			label: wrapper.find('.select__label'),
			ul: wrapper.find('.select__list'),
			options: select.find('option'),
			params: {}
		};

		try {
			result.params = JSON.parse(select.attr('data-select'));
		} catch(e) {
			result.params = {placeholder: 'Выберите значение...'};
		}
		
		result.params.clearItem = JSON.stringify(result.params.clearItem);

		return result;
	},

	/**
	 * Программное изменение выбранного значения
	 * Обновляет визуальное состояние и значение исходного select
	 *
	 * @param {jQuery} select - jQuery объект исходного select
	 * @param {string|number} index - значение для выбора
	 * @param {boolean} call - вызывать ли событие change
	 */
	change(select, index, call = true) {
		if (typeof index === 'object')
			index = JSON.stringify(index);

		if (typeof index !== 'number')
			index = index.replace(/"/g, '\\"');

		const
			elements = this.getElements(select),
			option = select.find(`[value="${index}"]`),
			oldVal = select.val();
		
		if (!option.length) 
			return false;

		const
			params = elements.params;

		elements.label.text(option.text());
		elements.label.removeClass('placeholder');
		select.val(option.val());

		// Обработка элемента сброса
		if (index == params.clearItem) {
			elements.label.addClass('placeholder');
			elements.label.text(params.placeholder);
		}

		// Вызываем событие change если значение изменилось
		if (call && select.val() !== oldVal)
			select.change();
	},

	/**
	 * Обработчик клика по элементу списка
	 * Устанавливает выбранное значение в селект
	 *
	 * @param {Event} event - событие клика
	 */
	selectItem(event) {
		const
			element = jQuery(event.currentTarget),
			select = element.closest('.select__wrapper').find('select'),
			index = element.attr('data-value');

		this.change(select, index);
	},

	/**
	 * Обработчик открытия/закрытия выпадающего списка
	 * Переключает видимость списка опций
	 *
	 * @param {Event} event - событие клика по лейблу
	 */
	open(event) {
		const
			element = jQuery(event.currentTarget),
			select = element.siblings('select'),
			elements = this.getElements(select);

		elements.wrapper.toggleClass('opened');
		elements.ul.toggleClass('opened');
	}
};

jQuery(document).ready(() => {
	CustomSelect.init();
});